'use strict';

import {StructureSectionsNavigCtrl} from './structuresectionsnavigctrl.js';

export class ReportingSectionsNavigCtrl extends StructureSectionsNavigCtrl {

    reportingCurrentIndex = 0;

    init($scope, jsDataService) {
        this.$scope = $scope;
        this.jsDataService = jsDataService || ($scope && $scope.jsDataService) || null;

        var ds = this.jsDataService;
        var strNodeList = ds ? ds.get('reportingStructureTreeNodeList', false) : false;

        if (false !== strNodeList) {
            this.nodeList = strNodeList || [];
            this.navigationList = (ds ? ds.get('reportingNavigationList', false) : []) || [];
        } else {
            this.makeStructureList(ds ? ds.get('reportingstructuretree', {}) : {});
            if (ds) {
                ds.set('reportingStructureTreeNodeList', this.nodeList);
                ds.set('reportingNavigationList', this.navigationList);
            }
        }

        var isFinalReporting = ds ? ds.get('is_final_reporting', false) : false;
        var balanceUrl = ds ? ds.get('balance_calculation_url', '') : '';

        if (isFinalReporting && balanceUrl) {
            var hasBalance = this.navigationList.some(function(n) {
                return n.key === 'balance_calculation';
            });

            if (!hasBalance) {
                var balanceNode = {
                    key: 'balance_calculation',
                    idkey: 'balance_calculation',
                    title: ds ? ds.get('translations', {})['payment_of_balance_calculation'] || 'Balance Calculation' : 'Balance Calculation',
                    number: '9.',
                    numbered: true,
                    preview_url: balanceUrl,
                    is_page: true,
                    level: 1
                };

                this.navigationList.push(balanceNode);

                if (ds) {
                    ds.set('reportingNavigationList', this.navigationList);
                }
            }
        }

        this.getIndexSync();
    }

    getIndexSync() {
        var idx = this.findIndexByCurrentUrl(this.navigationList);

        if (idx === -1) {
            var here = this.getHereUrl();
            if (here.indexOf('/balance') !== -1 && here.indexOf('/balance/') === -1) {
                idx = this.navigationList.length;
            }
        }

        if (idx === -1) {
            var ds = this.jsDataService;
            var stored = ds ? ds.get('reportingCurrentIndex', 0) : 0;
            if (stored >= 0 && this.navigationList && stored < this.navigationList.length) idx = stored; else idx = 0;
        }
        this.reportingCurrentIndex = idx;
        if (this.$scope) this.$scope.reportingCurrentIndex = idx;
        if (this.jsDataService && typeof this.jsDataService.set === 'function') {
            this.jsDataService.set('reportingCurrentIndex', idx);
        }
        return idx;
    }

    nodeTitleFormated(node) {
        var nr = '';
        if (node.numbered == 1 && node.number !== '') nr = node.number + ' ';
        return nr + node.title;
    }

    actionPreview(ev, node) {
        if (this.isPreview(node)) this.$scope.goUrl(node.preview_url);
    }

    actionEdit(ev, node) {
        if (this.isEdit(node)) this.$scope.goUrl(node.edit_url);
    }

    isPreviousLink() {
        var idx = this.getIndexSync();
        var mode = this.getCurrentMode();
        var prevIdx = idx - 1;
        if (prevIdx < 0) return false;

        if (prevIdx >= this.navigationList.length) {
            prevIdx = this.navigationList.length - 1;
        }

        var prev = this.navigationList[prevIdx];
        return this.hasUrlForMode(prev, mode);
    }

    isNextLink() {
        var idx = this.getIndexSync();
        var mode = this.getCurrentMode();
        var len = this.navigationList ? this.navigationList.length : 0;
        var nextIdx = idx + 1;
        if (nextIdx >= len) return false;
        var next = this.navigationList[nextIdx];
        return this.hasUrlForMode(next, mode);
    }

    navPrevious() {
        var idx = this.getIndexSync();
        var mode = this.getCurrentMode();
        var prevIdx = idx - 1;
        if (prevIdx < 0) return;
        var prev = this.navigationList[prevIdx];
        if (!this.hasUrlForMode(prev, mode)) return;
        var url = this.getNavigationUrl(prev, mode);
        if (url) {
            this.reportingCurrentIndex = prevIdx;
            if (this.$scope) this.$scope.reportingCurrentIndex = prevIdx;
            if (this.jsDataService && typeof this.jsDataService.set === 'function') {
                this.jsDataService.set('reportingCurrentIndex', prevIdx);
            }
            this.$scope.goUrl(url);
        }
    }

    navNext() {
        var idx = this.getIndexSync();
        var mode = this.getCurrentMode();
        var len = this.navigationList ? this.navigationList.length : 0;
        var nextIdx = idx + 1;
        if (nextIdx >= len) return;
        var next = this.navigationList[nextIdx];
        if (!this.hasUrlForMode(next, mode)) return;
        var url = this.getNavigationUrl(next, mode);
        if (url) {
            this.reportingCurrentIndex = nextIdx;
            if (this.$scope) this.$scope.reportingCurrentIndex = nextIdx;
            if (this.jsDataService && typeof this.jsDataService.set === 'function') {
                this.jsDataService.set('reportingCurrentIndex', nextIdx);
            }
            this.$scope.goUrl(url);
        }
    }

    getNavigationUrl(node, preferredMode) {
        if (!node) return '';
        if (preferredMode === 'edit' && typeof node.edit_url !== 'undefined' && node.edit_url) return node.edit_url;
        if (typeof node.preview_url !== 'undefined' && node.preview_url) return node.preview_url;
        if (typeof node.edit_url !== 'undefined' && node.edit_url) return node.edit_url;
        return '';
    }

    hasUrlForMode(node, mode) {
        if (!node) return false;
        if (mode === 'edit') return (typeof node.edit_url !== 'undefined' && !!node.edit_url);
        return (typeof node.preview_url !== 'undefined' && !!node.preview_url);
    }

    getPreviousLink() {
        var idx = this.getIndexSync();
        var mode = this.getCurrentMode();
        var prevIdx = idx - 1;
        if (prevIdx < 0) return '';

        if (prevIdx >= this.navigationList.length) {
            prevIdx = this.navigationList.length - 1;
        }

        var prev = this.navigationList[prevIdx];
        if (!this.hasUrlForMode(prev, mode)) return '';
        return this.getNavigationUrl(prev, mode);
    }

    getNextLink() {
        var idx = this.getIndexSync();
        var mode = this.getCurrentMode();
        var len = this.navigationList ? this.navigationList.length : 0;
        var nextIdx = idx + 1;
        if (nextIdx >= len) return '';
        var next = this.navigationList[nextIdx];
        if (!this.hasUrlForMode(next, mode)) return '';
        return this.getNavigationUrl(next, mode);
    }

    isPreview(node) {
        return (this.isAction(node) && typeof node.preview_url !== 'undefined');
    }

    isEdit(node) {
        return (this.isAction(node) && typeof node.edit_url !== 'undefined');
    }

    isAction(node) {
        return (typeof node.is_page !== 'undefined' &&
            (node.is_page === 1 ||
                node.is_page === '1' ||
                node.is_page === 'true' ||
                node.is_page === true));
    }

    isCurrent(node) {
        var idx = this.getIndexSync();
        if (!this.navigationList || !this.navigationList[idx]) return false;
        var cur = this.navigationList[idx];
        if (typeof cur.key !== 'undefined' && typeof node.key !== 'undefined' && cur.key === node.key) return true;
        if (typeof cur.idkey !== 'undefined' && typeof node.idkey !== 'undefined' && cur.idkey === node.idkey) return true;
        var mode = this.getCurrentMode();
        var curSeg = this.extractSectionSegment(this.getNavigationUrl(cur, mode));
        var nodeSeg = this.extractSectionSegment(this.getNavigationUrl(node, mode));
        return curSeg && nodeSeg && this.equalsLoose(curSeg, nodeSeg);
    }

    getCurrentMode() {
        var href = this.getHereUrl();
        var m = href && href.match(/\/(preview|edit)(?:[\/\?#]|$)/i);
        return m ? m[1].toLowerCase() : 'preview';
    }

    findIndexByCurrentUrl(list) {
        if (!list || !list.length) return -1;
        var here = this.getHereUrl();
        var seg = this.extractSectionSegment(here);
        if (!seg) return -1;
        var mode = this.getCurrentMode();
        for (var i = 0; i < list.length; i++) {
            var n = list[i];
            if (this.nodeMatchesSectionSegment(n, seg)) return i;
            var u = this.getNavigationUrl(n, mode);
            var nSeg = this.extractSectionSegment(u);
            if (u && nSeg && this.equalsLoose(nSeg, seg)) return i;
        }
        return -1;
    }

    getHereUrl() {
        try { return window.location.href; } catch (e) { return ''; }
    }

    extractSectionSegment(url) {
        if (!url) return '';
        var m = url.match(/\/section\/([^\/\?#]+)/i);
        return m ? decodeURIComponent(m[1]) : '';
    }

    equalsLoose(a, b) {
        if (a == null || b == null) return false;
        return String(a).toLowerCase() === String(b).toLowerCase();
    }

    nodeMatchesSectionSegment(node, seg) {
        if (!node || !seg) return false;
        var candidates = [];
        if (typeof node.key !== 'undefined') candidates.push(node.key);
        if (typeof node.idkey !== 'undefined') candidates.push(node.idkey);
        if (typeof node.id !== 'undefined') candidates.push(node.id);
        if (typeof node.slug !== 'undefined') candidates.push(node.slug);
        if (typeof node.code !== 'undefined') candidates.push(node.code);
        if (typeof node.alias !== 'undefined') candidates.push(node.alias);
        for (var i = 0; i < candidates.length; i++) {
            if (this.equalsLoose(candidates[i], seg)) return true;
        }
        return false;
    }
}
